module.exports = __webpack_public_path__ + "static/img/calendar-clipart-blue-9.222fe81c.png";